export default "__VITE_ASSET__56769e7c__"